import React from 'react';
import Link from 'next/link';

const links = {
  'For Candidates': [
    { label: 'How It Works', href: '/candidate' },
    { label: 'CV Improvement — R50', href: '/candidate#cv' },
    { label: 'Become Verified', href: '/candidate#verify' },
    { label: 'Candidate Dashboard', href: '/worker-dashboard' },
  ],
  'For Employers': [
    { label: 'Why Handlenders', href: '/employer' },
    { label: 'Browse Directory', href: '/directory' },
    { label: 'Pricing', href: '/employer#pricing' },
    { label: 'Employer Dashboard', href: '/employer-dashboard' },
  ],
  'Platform': [
    { label: 'Work-Readiness Framework', href: '/framework' },
    { label: 'Trust & Privacy', href: '/trust' },
    { label: 'About Us', href: '/about' },
    { label: 'Sign In', href: '/sign-up-login' },
  ],
};

export default function HomeFooter() {
  return (
    <footer style={{ background: 'var(--charcoal)', color: 'white' }}>
      <div className="max-w-screen-xl mx-auto px-4 lg:px-8 py-12 lg:py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-10">
          <div className="col-span-2 md:col-span-1">
            <div className="flex items-center gap-2 mb-3">
              <div className="w-7 h-7 rounded-lg flex items-center justify-center text-sm font-bold" style={{ background: 'var(--amber)', color: 'var(--charcoal)' }}>H</div>
              <span className="font-bold text-base" style={{ fontFamily: 'var(--font-serif)' }}>Handlenders</span>
            </div>
            <p className="text-xs text-white/50 leading-relaxed mb-1">Talent Network</p>
            <p className="text-sm text-white/50 leading-relaxed mb-4">
              Attitude First. Opportunity Follows.
            </p>
            <p className="text-xs text-white/35 leading-relaxed">
              South Africa&apos;s trusted work-readiness platform.
            </p>
          </div>

          {Object.entries(links)?.map(([group, items]) => (
            <div key={group}>
              <div className="text-xs font-bold uppercase tracking-widest text-white/40 mb-4">{group}</div>
              <ul className="flex flex-col gap-2.5">
                {items?.map((item) => (
                  <li key={item?.label}>
                    <Link
                      href={item?.href}
                      className="text-sm text-white/60 hover:text-white transition-colors"
                    >
                      {item?.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="border-t pt-6 flex flex-col sm:flex-row items-center justify-between gap-3" style={{ borderColor: 'rgba(255,255,255,0.1)' }}>
          <p className="text-xs text-white/40">© 2025 Handlenders Talent Network (Pty) Ltd. South African owned.</p>
          <div className="flex gap-4">
            <Link href="/trust" className="text-xs text-white/40 hover:text-white/70 transition-colors">POPIA Privacy Notice</Link>
            <Link href="/trust" className="text-xs text-white/40 hover:text-white/70 transition-colors">Terms & Conditions</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}